import { WheelData } from 'components/wheelOfFortune/WheelOfFortune/types';

import { TaskData } from '../components/TaskItem';
import { ReferralAnalyticsEvent } from '../types/';
import { ReferralEventData } from '../types/';
import { UserStatusApiResponse } from '../types/';

import { MOCK_TASK_BASED_EVENT_DATA, MOCK_TASKS, MOCK_WHEEL_DATA } from '../mocks/task-based-event.mock';

import { usePagination } from './usePagination';

const TASKS_PER_PAGE = 4;

interface UseTaskBasedEventReturn {
  data: ReferralEventData | undefined;
  analyticsEvents: ReferralAnalyticsEvent[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  userStatus: UserStatusApiResponse | undefined;
  wheelData: WheelData[];
  tasks: TaskData[];
  paginatedTasks: TaskData[];
  currentPage: number;
  totalPages: number;
  hasNextPage: boolean;
  hasPreviousPage: boolean;
  shouldShowPagination: boolean;
  goToPage: (page: number) => void;
  goToNextPage: () => void;
  goToPreviousPage: () => void;
}

export const useTaskBasedEvent = (): UseTaskBasedEventReturn => {
  const {
    paginatedItems: paginatedTasks,
    currentPage,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    shouldShowPagination,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  } = usePagination(MOCK_TASKS, { itemsPerPage: TASKS_PER_PAGE });

  return {
    data: MOCK_TASK_BASED_EVENT_DATA,
    analyticsEvents: MOCK_TASK_BASED_EVENT_DATA.analyticsEvents,
    isLoading: false,
    isError: false,
    error: null,
    userStatus: {
      status: 'REGISTERED',
      registered_at: '2025-10-01T00:00:00Z',
      unregistered_at: null,
      eligibility: {
        status: 'ELIGIBLE',
        global_blacklisted: false,
        event_blacklisted: false,
        whitelisted: false,
        conditions_met: true,
        reasons: [],
      },
      ama_verification: {
        status: 'NOT_VERIFIED',
        is_eligible_for_reward: false,
        code_verified_at: null,
      },
    },
    wheelData: MOCK_WHEEL_DATA,
    tasks: MOCK_TASKS,
    paginatedTasks,
    currentPage,
    totalPages,
    hasNextPage,
    hasPreviousPage,
    shouldShowPagination,
    goToPage,
    goToNextPage,
    goToPreviousPage,
  };
};
